import React, { useContext } from 'react'

import styled from 'styled-components';
import { STATIC_URL } from '../lib/settings';
import { Link } from 'react-router-dom';
import { DataContext } from '../contexts/DataContext';
import pages from '../lib/pages';

export default function SectionItem({title, authors, pieceId, image_path, isNextSlide}) {
  const { setPiece } = useContext(DataContext);

  const handleClickPiece = () => {
    if (isNextSlide) return;
    setPiece({id: pieceId, title, authors, image_path});
  }

  return (
    <SECTION_ITEM>
      <Link to={`${pages.pieces}/${pieceId}`}>
        <img src={`${STATIC_URL}/${image_path}`} alt={title}  onClick={handleClickPiece} loading='lazy' />
      </Link>
      <div className="bottom">
        <h3 onClick={handleClickPiece}>
          <Link to={`${pages.pieces}/${pieceId}`}>{title}</Link>
        </h3>
        <p>
          {authors?.map((author, index) => (
            <Link key={index} to={`${pages.authors}/${author.slug}`}>{author.full_name}</Link>
          ))}
        </p>
      </div>
    </SECTION_ITEM>
  )
}

const SECTION_ITEM = styled.section`
  margin-bottom: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  & img {
    margin-bottom: 1.125rem;
    width: 100%;
    height: 16.25rem;
    object-fit: contain;
  }

  & img:hover {
    cursor: pointer;
  }

  & a {
    text-decoration: none;
    color: black;
  }

  & .bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & h3 {
      margin-bottom: 0.35rem;
      font-size: 1rem;
      font-family: var(--primary-font);
      line-height: 22px;
      text-align: center;
    }

    & h3:hover {
      cursor: pointer;
    }

    & p {
      font-size: 0.875rem;
      font-family: var(--primary-font);
      line-height: 17px;
      text-align: center;
      color: black;
    }

    & p a:hover {
      text-decoration: underline;
    }

    & p a:not(:last-child)::after {
      content: ',';
      margin-right: 0.5rem;
    }
  }
`;